import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';
import { CommonConfig } from '../../../configs/config.common';
import { CallNative } from '../../../services/EpicContextService/call.native';

@Component
export default class HybridSuccessPage extends Vue {
    public data: string = '';
    public configs = new CommonConfig();

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    // query param
    public title: any = 'SUCCEED';

    // query param
    public text: any = '';

    public created() {
    }

    public mounted() {
        const query = this.$route.query;
        this.title = T_T.simpleDetect(query.title) ? query.title : 'Succeed';
        this.text = T_T.simpleDetect(query.text) ? query.text : 'Operation Succeed, Thanks For Chosing RIFO.';
    }

    public navToHome() {
        if (CallNative.isAndroid() || CallNative.isIos()) {
            CallNative.runNativeFun('nativeClose');
        } else {
            this.$router.push('/');
        }
    }

    public getRifoDesign(str: string) {
        return `${this.configs.rifoDesignAssetsUrl}/${str}`;
    }
}
